import React from 'react';
import Page from 'src/components/Page';
import Table from 'src/components/Table';

function CountryCodesPage() {

    return <Page header="Country codes">
        <Table
            headers={['Country', 'Alpha-3 Code']}
            body={[
                ['Afghanistan', <code>AFG</code>],
                ['Åland Islands', <code>ALA</code>],
                ['Albania', <code>ALB</code>],
                ['Algeria', <code>DZA</code>],
                ['American Samoa', <code>ASM</code>],
                ['Andorra', <code>AND</code>],
                ['Angola', <code>AGO</code>],
                ['Anguilla', <code>AIA</code>],
                ['Antarctica', <code>ATA</code>],
                ['Antigua and Barbuda', <code>ATG</code>],
                ['Argentina', <code>ARG</code>],
                ['Armenia', <code>ARM</code>],
                ['Aruba', <code>ABW</code>],
                ['Australia', <code>AUS</code>],
                ['Austria', <code>AUT</code>],
                ['Azerbaijan', <code>AZE</code>],
                ['Bahamas', <code>BHS</code>],
                ['Bahrain', <code>BHR</code>],
                ['Bangladesh', <code>BGD</code>],
                ['Barbados', <code>BRB</code>],
                ['Belarus', <code>BLR</code>],
                ['Belgium', <code>BEL</code>],
                ['Belize', <code>BLZ</code>],
                ['Benin', <code>BEN</code>],
                ['Bermuda', <code>BMU</code>],
                ['Bhutan', <code>BTN</code>],
                ['Bolivia', <code>BOL</code>],
                ['Bonaire', <code>BES</code>],
                ['Bosnia and Herzegovina', <code>BIH</code>],
                ['Botswana', <code>BWA</code>],
                ['Bouvet Island', <code>BVT</code>],
                ['Brazil', <code>BRA</code>],
                ['British Indian Ocean Territory', <code>IOT</code>],
                ['Brunei Darussalam', <code>BRN</code>],
                ['Bulgaria', <code>BGR</code>],
                ['Burkina Faso', <code>BFA</code>],
                ['Burundi', <code>BDI</code>],
                ['Cambodia', <code>KHM</code>],
                ['Cameroon', <code>CMR</code>],
                ['Canada', <code>CAN</code>],
                ['Cape Verde', <code>CPV</code>],
                ['Cayman Islands', <code>CYM</code>],
                ['Central African Republic', <code>CAF</code>],
                ['Chad', <code>TCD</code>],
                ['Chile', <code>CHL</code>],
                ['China', <code>CHN</code>],
                ['Christmas Island', <code>CXR</code>],
                ['Cocos (Keeling) Islands', <code>CCK</code>],
                ['Colombia', <code>COL</code>],
                ['Comoros', <code>COM</code>],
                ['Congo', <code>COG</code>],
                ['Congo, the Democratic Republic of the', <code>COD</code>],
                ['Cook Islands', <code>COK</code>],
                ['Costa Rica', <code>CRI</code>],
                ['Côte d\'Ivoire', <code>CIV</code>],
                ['Croatia', <code>HRV</code>],
                ['Cuba', <code>CUB</code>],
                ['Curaçao', <code>CUW</code>],
                ['Cyprus', <code>CYP</code>],
                ['Czech Republic', <code>CZE</code>],
                ['Denmark', <code>DNK</code>],
                ['Djibouti', <code>DJI</code>],
                ['Dominica', <code>DMA</code>],
                ['Dominican Republic', <code>DOM</code>],
                ['Ecuador', <code>ECU</code>],
                ['Egypt', <code>EGY</code>],
                ['El Salvador', <code>SLV</code>],
                ['Equatorial Guinea', <code>GNQ</code>],
                ['Eritrea', <code>ERI</code>],
                ['Estonia', <code>EST</code>],
                ['Ethiopia', <code>ETH</code>],
                ['Falkland Islands (Malvinas)', <code>FLK</code>],
                ['Faroe Islands', <code>FRO</code>],
                ['Fiji', <code>FJI</code>],
                ['Finland', <code>FIN</code>],
                ['France', <code>FRA</code>],
                ['French Guiana', <code>GUF</code>],
                ['French Polynesia', <code>PYF</code>],
                ['French Southern Territories', <code>ATF</code>],
                ['Gabon', <code>GAB</code>],
                ['Gambia', <code>GMB</code>],
                ['Georgia', <code>GEO</code>],
                ['Germany', <code>DEU</code>],
                ['Ghana', <code>GHA</code>],
                ['Gibraltar', <code>GIB</code>],
                ['Greece', <code>GRC</code>],
                ['Greenland', <code>GRL</code>],
                ['Grenada', <code>GRD</code>],
                ['Guadeloupe', <code>GLP</code>],
                ['Guam', <code>GUM</code>],
                ['Guatemala', <code>GTM</code>],
                ['Guernsey', <code>GGY</code>],
                ['Guinea', <code>GIN</code>],
                ['Guinea-Bissau', <code>GNB</code>],
                ['Guyana', <code>GUY</code>],
                ['Haiti', <code>HTI</code>],
                ['Heard Island and McDonald Islands', <code>HMD</code>],
                ['Holy See (Vatican City State)', <code>VAT</code>],
                ['Honduras', <code>HND</code>],
                ['Hong Kong', <code>HKG</code>],
                ['Hungary', <code>HUN</code>],
                ['Iceland', <code>ISL</code>],
                ['India', <code>IND</code>],
                ['Indonesia', <code>IDN</code>],
                ['Iran, Islamic Republic of', <code>IRN</code>],
                ['Iraq', <code>IRQ</code>],
                ['Ireland', <code>IRL</code>],
                ['Isle of Man', <code>IMN</code>],
                ['Israel', <code>ISR</code>],
                ['Italy', <code>ITA</code>],
                ['Jamaica', <code>JAM</code>],
                ['Japan', <code>JPN</code>],
                ['Jersey', <code>JEY</code>],
                ['Jordan', <code>JOR</code>],
                ['Kazakhstan', <code>KAZ</code>],
                ['Kenya', <code>KEN</code>],
                ['Kiribati', <code>KIR</code>],
                ['Korea, Democratic People\'s Republic of', <code>PRK</code>],
                ['Korea, Republic of', <code>KOR</code>],
                ['Kuwait', <code>KWT</code>],
                ['Kyrgyzstan', <code>KGZ</code>],
                ['Lao People\'s Democratic Republic', <code>LAO</code>],
                ['Latvia', <code>LVA</code>],
                ['Lebanon', <code>LBN</code>],
                ['Lesotho', <code>LSO</code>],
                ['Liberia', <code>LBR</code>],
                ['Libya', <code>LBY</code>],
                ['Liechtenstein', <code>LIE</code>],
                ['Lithuania', <code>LTU</code>],
                ['Luxembourg', <code>LUX</code>],
                ['Macao', <code>MAC</code>],
                ['Macedonia, the former Yugoslav Republic of', <code>MKD</code>],
                ['Madagascar', <code>MDG</code>],
                ['Malawi', <code>MWI</code>],
                ['Malaysia', <code>MYS</code>],
                ['Maldives', <code>MDV</code>],
                ['Mali', <code>MLI</code>],
                ['Malta', <code>MLT</code>],
                ['Marshall Islands', <code>MHL</code>],
                ['Martinique', <code>MTQ</code>],
                ['Mauritania', <code>MRT</code>],
                ['Mauritius', <code>MUS</code>],
                ['Mayotte', <code>MYT</code>],
                ['Mexico', <code>MEX</code>],
                ['Micronesia, Federated States of', <code>FSM</code>],
                ['Moldova, Republic of', <code>MDA</code>],
                ['Monaco', <code>MCO</code>],
                ['Mongolia', <code>MNG</code>],
                ['Montenegro', <code>MNE</code>],
                ['Montserrat', <code>MSR</code>],
                ['Morocco', <code>MAR</code>],
                ['Mozambique', <code>MOZ</code>],
                ['Myanmar', <code>MMR</code>],
                ['Namibia', <code>NAM</code>],
                ['Nauru', <code>NRU</code>],
                ['Nepal', <code>NPL</code>],
                ['Netherlands', <code>NLD</code>],
                ['New Caledonia', <code>NCL</code>],
                ['New Zealand', <code>NZL</code>],
                ['Nicaragua', <code>NIC</code>],
                ['Niger', <code>NER</code>],
                ['Nigeria', <code>NGA</code>],
                ['Niue', <code>NIU</code>],
                ['Norfolk Island', <code>NFK</code>],
                ['Northern Mariana Islands', <code>MNP</code>],
                ['Norway', <code>NOR</code>],
                ['Oman', <code>OMN</code>],
                ['Pakistan', <code>PAK</code>],
                ['Palau', <code>PLW</code>],
                ['Palestine, State of', <code>PSE</code>],
                ['Panama', <code>PAN</code>],
                ['Papua New Guinea', <code>PNG</code>],
                ['Paraguay', <code>PRY</code>],
                ['Peru', <code>PER</code>],
                ['Philippines', <code>PHL</code>],
                ['Pitcairn', <code>PCN</code>],
                ['Poland', <code>POL</code>],
                ['Portugal', <code>PRT</code>],
                ['Puerto Rico', <code>PRI</code>],
                ['Qatar', <code>QAT</code>],
                ['Réunion', <code>REU</code>],
                ['Romania', <code>ROU</code>],
                ['Russian Federation', <code>RUS</code>],
                ['Rwanda', <code>RWA</code>],
                ['Saint Barthélemy', <code>BLM</code>],
                ['Saint Helena, Ascension and Tristan da Cunha', <code>SHN</code>],
                ['Saint Kitts and Nevis', <code>KNA</code>],
                ['Saint Lucia', <code>LCA</code>],
                ['Saint Martin (French part)', <code>MAF</code>],
                ['Saint Pierre and Miquelon', <code>SPM</code>],
                ['Saint Vincent and the Grenadines', <code>VCT</code>],
                ['Samoa', <code>WSM</code>],
                ['San Marino', <code>SMR</code>],
                ['Sao Tome and Principe', <code>STP</code>],
                ['Saudi Arabia', <code>SAU</code>],
                ['Senegal', <code>SEN</code>],
                ['Serbia', <code>SRB</code>],
                ['Seychelles', <code>SYC</code>],
                ['Sierra Leone', <code>SLE</code>],
                ['Singapore', <code>SGP</code>],
                ['Sint Maarten (Dutch part)', <code>SXM</code>],
                ['Slovakia', <code>SVK</code>],
                ['Slovenia', <code>SVN</code>],
                ['Solomon Islands', <code>SLB</code>],
                ['Somalia', <code>SOM</code>],
                ['South Africa', <code>ZAF</code>],
                ['South Georgia and the South Sandwich Islands', <code>SGS</code>],
                ['South Sudan', <code>SSD</code>],
                ['Spain', <code>ESP</code>],
                ['Sri Lanka', <code>LKA</code>],
                ['Sudan', <code>SDN</code>],
                ['Suriname', <code>SUR</code>],
                ['Svalbard and Jan Mayen', <code>SJM</code>],
                ['Swaziland', <code>SWZ</code>],
                ['Sweden', <code>SWE</code>],
                ['Switzerland', <code>CHE</code>],
                ['Syrian Arab Republic', <code>SYR</code>],
                ['Taiwan, Province of China', <code>TWN</code>],
                ['Tajikistan', <code>TJK</code>],
                ['Tanzania, United Republic of', <code>TZA</code>],
                ['Thailand', <code>THA</code>],
                ['Timor-Leste', <code>TLS</code>],
                ['Togo', <code>TGO</code>],
                ['Tokelau', <code>TKL</code>],
                ['Tonga', <code>TON</code>],
                ['Trinidad and Tobago', <code>TTO</code>],
                ['Tunisia', <code>TUN</code>],
                ['Turkey', <code>TUR</code>],
                ['Turkmenistan', <code>TKM</code>],
                ['Turks and Caicos Islands', <code>TCA</code>],
                ['Tuvalu', <code>TUV</code>],
                ['Uganda', <code>UGA</code>],
                ['Ukraine', <code>UKR</code>],
                ['United Arab Emirates', <code>ARE</code>],
                ['United Kingdom', <code>GBR</code>],
                ['United States', <code>USA</code>],
                ['United States Minor Outlying Islands', <code>UMI</code>],
                ['Uruguay', <code>URY</code>],
                ['Uzbekistan', <code>UZB</code>],
                ['Vanuatu', <code>VUT</code>],
                ['Venezuela, Bolivarian Republic of', <code>VEN</code>],
                ['Viet Nam', <code>VNM</code>],
                ['Virgin Islands, British', <code>VGB</code>],
                ['Virgin Islands, U.S.', <code>VIR</code>],
                ['Wallis and Futuna', <code>WLF</code>],
                ['Western Sahara', <code>ESH</code>],
                ['Yemen', <code>YEM</code>],
                ['Zambia', <code>ZMB</code>],
                ['Zimbabwe', <code>ZWE</code>],
            ]}
        />
    </Page>
}

export default CountryCodesPage;